#import "../fragments/EventCancelProgressFields.graphql"

query EventCancelProgress($productId: ID!) {
  eventCancelProgress(productId: $productId) {
    ...EventCancelProgressFields
  }
}
